import { ConfigObj, CssModifiers, MediaQuery } from '../utils'

const defaultOpts = {
    offset: 175
}

export default class InView {
    constructor($el, opts) {
        this.$el = $el
        this.options = ConfigObj.merge(defaultOpts, opts)
    }

    init() {
        window.addEventListener('scroll', this.isInRange.bind(this))
    }

    isInRange() {
        let bounding = this.$el.getBoundingClientRect()
        if (bounding.top <= this.options.offset) {
            this.$el.classList.add('ps-animation-triggered')
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/InView.js